import json from '../../static/data.json';

let data = json.test;

class Test {

	constructor ($elem) {

		this.testNode = $elem.find('.test');
		this.shareNode = $elem.find('.result-share');


		this.counter = {
			current: $elem.find('.test__counter-current'),
			total: $elem.find('.test__counter-total')
		};

		this.redirectUrl = '/result/';

		this.currentQuestion = 0;
		this.totalQuestion = 4;

		this.questionImage = $elem.find('.question__image');
		this.questionText = $elem.find('.question__text');
		this.questionAnswers = $elem.find('.answers__list');

		this.isLocked = false;
		this.lockTime = 2000;

		this.shareButtons = $elem.find('.share__buttons-item');
		this.authButtons = $elem.find('.auth__buttons-item');
		this.shareUrl = 'http://lapki.kinoafisha.info/';
		this.shareImage = 'http://lapki.kinoafisha.info/img/share.jpg';

		this.results = {};
		this.answers = {};

		this.init();
	}

	init () {
		this.loadNode(this.testNode);
		this.loadStep(1);

		this.bindSocialClick();
		this.bindAuthClick()
	}

	loadNode (elem) {
		this.shareNode.hide();
		this.testNode.hide();

		elem.show();

		if (elem == this.shareNode){
			$('body').addClass('result-page');
		}
	}

	setClass(id){
		let $body = $('body');
		$body.removeClass('test-step-1 test-step-2 test-step-3 test-step-4');
		$body.addClass('test-step-' + id);
	}

	loadStep (id) {
		if (id > this.totalQuestion) {
			this.loadResult();
			return false;
		}

		this.questionImage.attr('data-question', id);
		this.counter.current.text(id);

		console.log(id);

		this.currentQuestion = id;

		let arrayId = --id;
		this.questionAnswers.html('');

		for (let i in data.question[arrayId].answers) {

			let answer = data.question[arrayId].answers[i];

			//console.log(answer);

			let currentAnswerImg = $('<img/>', {
				src: answer.img,
				alt: answer.id
			});

			let currentAnswer = $('<li/>', {
				class: 'answers__item'
			});

			currentAnswer.append(currentAnswerImg);
			currentAnswer.attr('data-choice', parseInt(i) + 1);
			this.questionAnswers.append(currentAnswer);
		}

		this.setClass(this.currentQuestion);

		this.questionText.html(data.question[arrayId].text);

		this.bindClick();

	}

	loadResult () {
		this.loadNode(this.shareNode);
	}

	bindClick () {
		let $answers = this.questionAnswers.find('.answers__item');
		console.log('answers length', $answers.length);
		$answers.on('click', (e) => {
			this.handleClick(e);
		})
	}

	handleClick (e) {
		if (this.isLocked) {
			return false;
		}

		this.isLocked = true;

		let $answer = $(e.target).closest('.answers__item');
		let choice = $answer.attr('data-choice');

		let isCorrect = (choice === data.question[this.currentQuestion - 1].correctId);
		this.results[this.currentQuestion] = isCorrect;
		this.answers[this.currentQuestion] = choice;

		let chosenClass = isCorrect ? 'active_true' : 'active_false';
		$answer.addClass('active');
		$answer.addClass(chosenClass);

		let resultText = (isCorrect ? data.question[this.currentQuestion - 1].afterText.correct : data.question[this.currentQuestion - 1].afterText.incorrect);
		this.questionText.html(resultText);

		setTimeout(() => {
			this.isLocked = false;
			this.loadStep(this.currentQuestion + 1);
		}, this.lockTime);
	}

	bindSocialClick(){
		this.shareButtons.on('click', (e) => {
			let $btn = $(e.currentTarget).closest('.share__buttons-item');
			let social = $btn.attr('data-social');

			if (social == 'vk'){
				this.shareVk();
			} else if (social == 'fb'){
				this.shareFb();
			}
		})
	}
	
	bindAuthClick(){
		this.authButtons.on('click', (e) => {
			let $btn = $(e.currentTarget).closest('.auth__buttons-item');
			let social = $btn.attr('data-social');

			if (social == 'vk'){
				this.handleVk();
			} else if (social == 'fb'){
				this.handleFb();
			}
		})
	}

	handleVk () {
		VK.Auth.login((response) => {
			if (response.session) {
				var data = {
					"name": response.session.user.first_name,
					"social_id": response.session.user.id,
					"email": response.email,
					"social_network": "vk"
				};
				this.afterAuth(data);
			}
		}, 4202496)
	}
	
	shareVk () {
		let win = window.open('https://vk.com/share.php?url=' + this.shareUrl + '&image=' + this.shareImage,'displayWindow', 'width=700,height=400,left=200,top=100,location=no, directories=no,status=no,toolbar=no,menubar=no');
		if (win){
			const timer = setInterval(()=> {
				if (win.closed) {
					clearInterval(timer);
					$.ajax({
						'url':' /share/',
						'data': {'share_network':'vk'},
						'method':'POST',
						success:function(){}
					});
				}
			}, 100);
		}
	}

	handleFb () {
		FB.login((response) => {
			if(response.status=='connected'){
				FB.api('/me?fields=name,email', (response) => {
					let data = {"name":response.name, "social_id":response.id, "email":response.email, "social_network":"fb"};
					//let isMobile = ($(window).width() < 1000);
					let isMobile = true;
					this.afterAuth(data);
				});
			}
		}, {scope: 'public_profile,email,publish_actions'});
	}
	
	shareFb (){
		FB.ui({
				method: 'share',
				mobile_iframe: isMobile, //ЭТО ЕСЛИ С МОБИЛЬНОГО
				quote: '', //Смотрите, какой я сосед! Кто пойдёт со мной в кино бесплатно?
				href: this.shareUrl
			},
			(response) => {
				$.ajax({
					'url':' /share/',
					'data': {'share_network': 'fb'},
					'method':'POST',
					success:function(){}
				});
				console.log(response);
			});
	}

	afterAuth (data) {
		// email required block
		if (!data.email)
			this.sendData(data, true);
		else
			this.sendData(data, false);
	}

	getResult (send) {
		let n = 0;
		for (let i in this.results){
			if (this.results.hasOwnProperty(i)){
				if (this.results[i]){
					console.log(this.results[i]);
					n++;
				}
			}
		}
		if(send){
			let request = $.ajax({
				'url': '/answers/',
				'data': this.answers,
				'method': 'POST'
			});
		}
		return n;
	}

	sendData (data, isEmailStillRequired) {
		let res = this.getResult(true);
		console.log(data, res);
		//return false;

		let request = $.ajax({
			'url': '/user/',
			'data': data,
			'method': 'POST'
		});

		request.done((msg) => {
			let res = this.getResult(false);
			let page;

			if (res < 1) {
				page = '1'
			}
			else if (res < 3) {
				page = '2'
			}
			else page = '3';

			window.location.assign(this.redirectUrl + page + (isEmailStillRequired ? '?email=0' : ''));
		});

		request.fail(function (jqXHR, textStatus) {
			alert('Произошла ошибка. Пожалуйста, перезагрузите браузер, проверьте соединение с интернетом и попробуйте еще раз.');
		});
	}

}

export default Test;